import React from 'react'
import { useTranslation } from 'react-i18next'
import { motion } from 'framer-motion'

// PDF Katalog Verileri
const catalogData = [
  {
    name: "FORMWORK SYSTEMS",
    path: "https://online.fliphtml5.com/bimmb/jfdn/#p=1",
    isFlipbook: true
  },
  {
    name: "SCAFFOLDING SYSTEMS",
    path: "/pdf/scaffolding-systems.pdf"
  },
  {
    name: "04.12 SLAB FORMWORK SYSTEMS",
    path: "/pdf/0412-slab-formwork-systems.pdf"
  },
  {
    name: "02.10 CIRCULAR COLUMN FORMWORK SYSTEMS",
    path: "/pdf/0210-circular-column-formwork-systems.pdf"
  },
  {
    name: "01.10.A MO-KAI PLYWOOD SURFACE FORMWORK SYSTEM(COLUMN) - PART 1",
    path: "/pdf/0110a-mo-kai-plywood-surface-formwork-systemcolumn-part-1.pdf"
  },
  {
    name: "01.10.A MO-KAI PLYWOOD SURFACE FORMWORK SYSTEM(COLUMN) - PART 2",
    path: "/pdf/0110a-mo-kai-plywood-surface-formwork-systemcolumn-part-2.pdf"
  },
  {
    name: "01.10.A MO-KAI PLYWOOD SURFACE FORMWORK SYSTEM(COLUMN) - PART 3",
    path: "/pdf/0110a-mo-kai-plywood-surface-formwork-systemcolumn-part-3.pdf"
  },
  {
    name: "01.10.B MO-KAI PLYWOOD SURFACE FORMWORK SYSTEM(WALL- CORE WALL)",
    path: "/pdf/0110b-mo-kai-plywood-surface-formwork-systemwall-core-wall.pdf"
  },
  {
    name: "01.12 MO-KAI PLYWOOD SURFACE FORMWORK SYSTEM(INDUSTRIAL) - PART 1",
    path: "/pdf/0112-mo-kai-plywood-surface-formwork-systemindustrial-part-1.pdf"
  },
  {
    name: "01.12 MO-KAI PLYWOOD SURFACE FORMWORK SYSTEM(INDUSTRIAL) - PART 2",
    path: "/pdf/0112-mo-kai-plywood-surface-formwork-systemindustrial-part-2.pdf"
  },
  {
    name: "01.13 STEEL SURFACE FORMWORK SYSTEM(MS 53 - COLUMN-WALL)",
    path: "/pdf/0113-steel-surface-formwork-systemms-53-column-wall.pdf"
  },
  {
    name: "01.14 STEEL SURFACE FORMWORK SYSTEM(MS 63 - COLUMN-WALL)",
    path: "/pdf/0114-steel-surface-formwork-systemms-63-column-wall.pdf"
  },
  {
    name: "01.15 STEEL SURFACE FORMWORK SYSTEM(MS 83 - COLUMN-WALL)",
    path: "/pdf/0115-steel-surface-formwork-systemms-83-column-wall.pdf"
  },
  {
    name: "01.16 STEEL SURFACE FORMWORK SYSTEM(SOLDIER TYPE WALL)",
    path: "/pdf/0116-steel-surface-formwork-systemsoldier-type-wall.pdf"
  },
  {
    name: "4-10.11 TABLE TYPE SCAFFOLDING SYSTEMS",
    path: "/pdf/041011-table-type-scaffolding-systems.pdf"
  },
  {
    name: "05.10 CLIMBING FORMWORKS SYSTEMS",
    path: "/pdf/0510-climbing-formworks-systems.pdf"
  },
  {
    name: "05.11 IRRIGATION STRUCTURES FORMWORK SYSTEMS",
    path: "/pdf/0511-irrigation-structures-formwork-systems.pdf"
  },
  {
    name: "05.12 TRANSPORTATION PROJECTS FORMWORK SYSTEMS",
    path: "/pdf/0512-transportation-projects-formwork-systems.pdf"
  },
  {
    name: "05.13 WIND TURBINE BASE FORMWWORK SYSTEMS",
    path: "/pdf/0513-wind-turbine-base-formwwork-systems.pdf"
  },
  {
    name: "06.10 PATTERNED WALL FORMWORK SYSTEMS",
    path: "/pdf/0610-patterned-wall-formwork-systems.pdf"
  },
  {
    name: "06.11 MINARET FORMWORKS SYSTEMS",
    path: "/pdf/0611-minaret-formworks-systems.pdf"
  },
  {
    name: "06.12 STAIRCASE FORMWORK SYSTEMS",
    path: "/pdf/0612-staircase-formwork-systems.pdf"
  },
  {
    name: "06.13 BALCONY FORMWORK SYSTEMS",
    path: "/pdf/0613-balcony-formwork-systems.pdf"
  },
  {
    name: "06.14 SOCKET FORMWORK SYSTEMS",
    path: "/pdf/0614-socket-formwork-systems.pdf"
  },
  {
    name: "06.15 POOL FORMWORK SYSTEMS",
    path: "/pdf/0615-pool-formwork-systems.pdf"
  },
  {
    name: "06.16 OTHER MANUFACTURING SYSTEMS",
    path: "/pdf/0616-other-manufacturing-systems.pdf"
  },
  {
    name: "07.10 MATERIAL ELEVATING PLATFORM",
    path: "/pdf/0710-material-elevating-platform.pdf"
  },
  {
    name: "07.11 WIND PROTECTION SYSTEM",
    path: "/pdf/0711-wind-protection-system.pdf"
  },
  {
    name: "07.12 PROTECTIVE SECURITY SYSTEMS",
    path: "/pdf/0712-protective-security-systems.pdf"
  }
];

const Kataloglar = () => {
  const { t } = useTranslation();

  return (
    <div className="bg-white min-h-screen pb-20">
 
      <div className="grid grid-cols-14 md:grid-cols-8">
        <div className="col-start-2 col-span-12 md:col-start-2 md:col-span-6">
            <div className="text-45 font-light mb-10">{t('catalogs.title')}</div>

            <motion.div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {catalogData.map((catalog, index) => (
                <div  key={index} className='hover:shadow-md transition-all duration-300 hover:scale-105'>
                <motion.a 
                 
                  href={catalog.path}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block bg-gray-50 p-6 cursor-pointer"
                  initial={{ opacity: 0, scale: 0.9 }}
                  whileInView={{
                    opacity: 1,
                    scale: 1,
                    transition: {
                      type: "spring",
                      stiffness: 100,
                      damping: 10,
                      delay: index * 0.1,
                    },
                  }}
                >
                  <div className="flex items-center justify-between mb-4">
                    <div className="flex items-center">
                      {catalog.isFlipbook ? (
                        <svg className="w-5 h-5 text-blue-600 mr-2" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M4 4a2 2 0 00-2 2v8a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2H4zm2 2h8v8H6V6z" clipRule="evenodd" />
                          <path d="M6 10h8M6 8h8M6 12h8" stroke="white" strokeWidth="0.5"/>
                        </svg>
                      ) : (
                        <svg className="w-5 h-5 text-red-600 mr-2" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2 6a1 1 0 011-1h6a1 1 0 110 2H7a1 1 0 01-1-1zm1 3a1 1 0 100 2h6a1 1 0 100-2H7z" clipRule="evenodd" />
                        </svg>
                      )}
                      <span className="text-xs text-gray-500">
                        {catalog.isFlipbook ? "DIGITAL" : "PDF"}
                      </span>
                    </div>
                    
                    <div className="flex items-center">
                      {catalog.isFlipbook ? (
                        <svg className="w-5 h-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                        </svg>
                      ) : (
                        <svg className="w-5 h-5 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                        </svg>
                      )}
                    </div>
                  </div>
                  
                  <h3 className="text-lg font-light text-gray-900 mb-6 ">
                    {catalog.name}
                  </h3>
                </motion.a>
                </div>
              ))}
            </motion.div>
            
        </div>
      </div>
    </div>
  )
}

export default Kataloglar